import styled from 'styled-components';
import { AdminOverview as BaseAdminOverview, ItemButton, urlEncodeObject } from '@code-yellow/spider';
import { StyledTableCell } from './StyledTableCell';
import Toolbar from './Toolbar';
import { theme } from 'styles';
import { TAB_TITLE_PREFIX } from 'helpers';
import {
  Model as BaseModel,
  Store as BaseStore
} from 'store/Base';
import { AdminOverviewButtons } from './AdminOverview/AdminOverviewButtons';
import { ToolbarItems } from './AdminOverview/ToolbarItems';
import { AdminOverviewFilters } from './AdminOverview/Filters';
import React, { ReactNode } from 'react';
import { t } from 'i18n';
import { observable } from 'mobx';

export const TableFormCell = styled(StyledTableCell)`
     > .field > .ui.dropdown {
        margin: calc(-0.78571429em - 1px) calc(-2.5em - 1px) calc(-0.78571429em - 1px) calc(-1em - 1px);
        &.multiple {
            margin-left: calc(-0.35714286em - 1px);
            margin-right: calc(-2.1em - 1px);
        }
        &.fluid {
            width: unset;
        }
        &:not(.active) {
            border-color: transparent !important;
            background-color: transparent !important;
            > .dropdown.icon {
                display: none;
            }
        }
    }

    > .field > .ui.input {
        margin: calc(-0.67857143em - 1px) calc(-1em - 1px);
        &.time-picker > input {
            width: 4.8em !important;
        }
        &.fluid > input {
            width: unset !important;
        }
        > input {
            &:focus {
                box-shadow: 0px 2px 3px 0px rgba(34, 36, 38, 0.15);
                background-color: #FFF !important;
            }
            &:not(:focus) {
                border-color: transparent !important;
                background-color: transparent !important;
            }
        }
    }

    > .field:has(.daycy.date-picker) {
        position: relative;
    }

    > .field > .ui.input.daycy.date-picker {
        width: 9rem;
        > input {
            padding-right: 2.1em;
        }
    }

    > .field > .daycy.date-picker + i.icon {
        position: absolute;
        top: 50%;
        right: calc(-1em - 1px);
        height: auto !important;
        transform: translateY(-50%);
        z-index: 11;
    }
`;


export interface AdminOverviewSetting<
  Model extends BaseModel,
> {
  attr?: string | ((model: Model) => JSX.Element | string | ReactNode);
  label?: string | null;
  sortKey?: string;
  cellProps?: { [name: string]: any };
}

/**
 *  AdminOverview with specifics for the project
 *
 *  Contains some overrides for the typing that is missing from spider as well
 */
export default class AdminOverview<
  Model extends BaseModel,
  Store extends BaseStore
> extends BaseAdminOverview {

  TableCell = TableFormCell;
  Toolbar = Toolbar;
  fullWidth = true;

  toggleFgColor = theme.primaryColor;
  toggleBgColor = 'transparent';

  toggleActiveFgColor = '#FFF';
  toggleActiveBgColor = theme.primaryColor;

  dashboardBackgroundColor = theme.sidebarColor;
  dashboardBorderBottomColor = '' as any;

  highlightedRows = true;

  store: Store | undefined;

  // @ts-ignore
  tabTitlePrefix = TAB_TITLE_PREFIX;

  // @ts-ignore
  myFilterKey: string | null;

  // @ts-ignore
  relations: string[]

  filters: AdminOverviewFilters = [];

  @observable settings: (AdminOverviewSetting<Model> | string)[] = [];

  // @ts-ignore
  buttons: AdminOverviewButtons<Model> = [];

  // @ts-ignore
  toolbar: ToolbarItems = []

  defaultShowSidebar = true;

  renderCounter = true;

  renderExportButton = () => {
    return (
      <ItemButton primary compact data-test-data-export
        style={{ display: 'flex', marginLeft: '4px' }}
        icon='download'
        label={t('form.exportButton')}
        as='a'
        // @ts-ignore
        href={`/api/${this.store?.Model.backendResourceName}/download/?${urlEncodeObject(this.store?.params)}`}
        // onClick={() => showNotification(t('general.exportInProgress'))}
        download={'CSV_Export'}
      />
    );
  }

  rowProps(item: any, i: number) {
    return {
      ...super.rowProps(item, i),
      [`data-test-${item.constructor.backendResourceName.replace(/_/g, '-')}`]: item.getInternalId().toString(),
    };
  }

  // @ts-ignore
  bulkActions: any[] | (() => any[]) = [];

}